import { render, staticRenderFns } from "./BookEngine.vue?vue&type=template&id=21bfa387&scoped=true&"
import script from "./BookEngine.vue?vue&type=script&lang=js&"
export * from "./BookEngine.vue?vue&type=script&lang=js&"
import style0 from "./BookEngine.vue?vue&type=style&index=0&id=21bfa387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bfa387",
  null
  
)

export default component.exports